<div class="flex gap-4 items-center bizz-alert px-6 py-4 rounded"
     [class]="type">
    @if (icon) {
        <bizz-icon class="min-h-8 min-w-8 size-8 alert-icon" [iconName]="icon"></bizz-icon>
    }
    <p [class]="{'text-left': align() == 'left'}" class="text-sm font-medium">{{ message }}</p>
</div>